export enum SQLTextValidationEnum {
    UPDATE = "UPDATE",
    DELETE = "DELETE",
    SET = "SET",
    TRUNCATE = "TRUNCATE",
    DROP = "DROP",
    INSERT = "INSERT",
    DECLARE = "DECLARE",
}